export default __webpack_public_path__ + "assets/edit.636b8e73.svg";